/** Indian number conventions, used everywhere a figure is shown. */

export const num = (n) => Number(n || 0);

export const inr = (n, decimals = 2) =>
  `₹${num(n).toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;

/** ₹12.35 L / ₹1.23 Cr for tiles and axes; the full figure goes in the tooltip. */
export function inrCompact(n) {
  const v = num(n);
  const a = Math.abs(v);
  if (a >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  if (a >= 1e3) return `₹${Math.round(v).toLocaleString('en-IN')}`;
  return `₹${v.toFixed(0)}`;
}

export function compact(n) {
  const v = num(n);
  const a = Math.abs(v);
  if (a >= 1e7) return `${(v / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `${(v / 1e5).toFixed(2)} L`;
  if (a >= 1e3) return `${(v / 1e3).toFixed(1)}K`;
  return String(Math.round(v * 100) / 100);
}

export const qty = (n, unit) =>
  `${num(n).toLocaleString('en-IN', { maximumFractionDigits: 3 })}${unit ? ` ${unit}` : ''}`;

export const count = (n) => num(n).toLocaleString('en-IN');

export const day = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : '—');
export const dayShort = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : '');
export const stamp = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');

/** "4 minutes ago" — the only honest way to show a sync timestamp. */
export function ago(d) {
  if (!d) return 'never';
  const secs = Math.max(0, (Date.now() - new Date(d).getTime()) / 1000);
  if (secs < 90) return 'just now';
  if (secs < 3600) return `${Math.round(secs / 60)} min ago`;
  if (secs < 86400) return `${Math.round(secs / 3600)} h ago`;
  return `${Math.round(secs / 86400)} d ago`;
}

/**
 * Percentage change against a comparison period. `goodWhenUp = false` inverts the
 * colour, for cost-type measures.
 */
export function delta(current, previous, goodWhenUp = true) {
  const c = num(current);
  const p = num(previous);
  if (!p) return c > 0 ? { dir: 'up', text: 'new', good: goodWhenUp } : { dir: 'flat', text: 'no change', good: true };
  const pct = ((c - p) / Math.abs(p)) * 100;
  const dir = Math.abs(pct) < 0.5 ? 'flat' : pct > 0 ? 'up' : 'down';
  return {
    dir,
    pct,
    text: `${pct > 0 ? '+' : ''}${pct.toFixed(1)}%`,
    good: dir === 'flat' ? true : (dir === 'up') === goodWhenUp,
  };
}
